export interface ISecurityQuestion {
	id: string,
	version: number,
	name: string,
	question: string
}

export interface ISecurityQuestionsAnswers {
	newPassword: string,
	username: string,
	securityAnswers: Array<IAnswersOfSelectedQuestions>
}

export interface IAnswersOfSelectedQuestions {
	answer: string,
	securityQuestion: {
		id: string
	}
}
